import { useCallback, useEffect } from "react";

import { isEqual } from "lodash";

import { useCurrentIndex, useHistoryAtom } from "../atoms";

import { useFormulaBuilder } from "./use-formula-builder";

export const useFormulaHistory = () => {
  const { formula, updateFormula } = useFormulaBuilder();
  const [history, setHistory] = useHistoryAtom();
  const [currentIndex, setCurrentIndex] = useCurrentIndex();

  const pushToHistory = useCallback(
    (newArray) => {
      setHistory((prevHistory) => {
        const newHistory = prevHistory.slice(0, currentIndex + 1);
        newHistory.push(newArray);
        setCurrentIndex(newHistory.length - 1);
        return newHistory;
      });
    },
    [currentIndex, setCurrentIndex, setHistory],
  );

  useEffect(() => {
    if (!isEqual(history[currentIndex], formula)) {
      pushToHistory(formula);
    }
  }, [formula, history, currentIndex, pushToHistory]);

  const undoHistory = useCallback(() => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      updateFormula(history[currentIndex - 1]);
    }
  }, [currentIndex, history, updateFormula, setCurrentIndex]);

  const clearHistory = useCallback(() => {
    setHistory([]);
    setCurrentIndex(0);
  }, [setHistory, setCurrentIndex]);

  const resetHistory = useCallback(() => {
    if (history.length === 0) {
      return;
    }
    updateFormula(history[0]);
    setHistory([history[0]]);
    setCurrentIndex(0);
  }, [history, updateFormula, setHistory, setCurrentIndex]);

  return {
    undoHistory,
    clearHistory,
    resetHistory,
    canClear: history.length > 0,
    canUndo: currentIndex > 1,
  };
};
